module.exports = __webpack_public_path__ + "img/card_header_help_timeline.225d56ea.jpg";